import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { UserProvider } from 'src/app/modules/auth/providers/user.service';
import { DEFAULT_VALUES } from 'src/app/constants/default.values';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  constructor(private userProvider: UserProvider) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    const tokenInfo = this.userProvider.getAccessToken(false);

    if (request.url.includes('blob.core.windows.net')) {
      return next.handle(request);
    }

    request = request.clone({
      setHeaders: {
        Authorization: `Bearer ${tokenInfo?.token || ""}`,
        companyId: tokenInfo?.companyId || "",
        'X-Legal-Entity-Id': tokenInfo?.legalEntityId || DEFAULT_VALUES.Guid
      }
    });

    return next.handle(request);
  }
}
